<template>
    <div class="d-flex align-items-center flex-wrap flex-md-nowrap templete-reference">
      <div class="p-3 first-area qrcode">
        <div ref="qrcodearea"></div>
      </div>
      <div class="second-area">
            <p>Use your banking app to scan this QR code or PayNow to <strong>UEN 200615440H</strong>. If you're on a mobile device, screenshot this page and upload it to your banking app.</p>
            <div class="bg-hs-pastel-crimson p-3">
              <h5 style="margin-bottom: 3px; font-weight: bold; font-size: 16px; line-height: 24px;">Your reference number </h5>
              <code>{{checkout.Reference}}</code>
            </div>
      </div>
    </div>

</template>

<script>
import PaynowQR from 'paynowqr';
import paynowlogo from '@/assets/paynow.png';
import QRCode from 'easyqrcodejs';
export default {
    name:"paynow",
    data(){
      let qrcode = new PaynowQR({
          uen:"200615440H",
          amount: this.checkout.Donation_Cash_Value,
          refNumber:this.checkout.Reference,
          company:"HealthServe Ltd."

        });
        return {
          qrString: qrcode.output(),
        };
    },
    mounted(){
        new QRCode(this.$refs.qrcodearea, {
          text:this.qrString,
          colorDark:'#7D1979',
          logo:paynowlogo,
          correctLevel : QRCode.CorrectLevel.H,
        });
    },
    props:{
        checkout: Object
    },
    computed:{
      paynowlogo(){
        return paynowlogo
      }
    }
}
</script>

<style>

</style>